import { Component, ElementRef, Input, OnInit, ViewChild, Output, EventEmitter, OnChanges } from '@angular/core';
import { SaveObjectInLocalServiceService } from '@app/core/services/save-object-in-local-service.service';

@Component({
  selector: 'dhl-toggle-slider',
  templateUrl: './toggle-slider.component.html',
  styleUrls: ['./toggle-slider.component.scss']
})
export class ToggleSliderComponent implements OnInit {

  private CLASS_TRANSLATE_SLIDER_OFF: string = 'slider-off';
  private CLASS_TRANSLATE_SLIDER_ON: string = 'slider-on';
  private CLASS_BACKGROUND_RED_SLIDER_ACTIVE: string = 'bg-red';

  private STATUS_ACTIVE: string = 'add';
  private STATUS_REMOVE: string = 'remove';

  private ASW_YES: string = "Si";
  private ASW_NO: string = "No";


  @Input() isPreferenceData: boolean = false;
  @Input() isActive: boolean = false;
  @Output() isPreferenceDtaFEmit = new EventEmitter<boolean>;

   defaultPreference: string = this.ASW_NO;

  @ViewChild('silder') silder!: ElementRef;
  @ViewChild('circleSlid') circleSlid!: ElementRef;
  @ViewChild('divSlider') divSlider!: ElementRef;
  @ViewChild('isPreference') isPreference!: ElementRef;

  constructor(){}
  ngOnInit(): void {
  }


  //Metodo para poder activar el slider o botón donde permitirá establecer los datos ingresados de facturación como preferidos
  onOroffToggle(){
    const circle = this.circleSlid.nativeElement;
    const divSlider = this.divSlider.nativeElement;
    if(this.silder.nativeElement.checked){
      this.defaultPreference = this.ASW_YES;
      this.isPreferenceData = true;
      this.addOrRemoveClassListMethod(circle, this.CLASS_TRANSLATE_SLIDER_ON, this.STATUS_ACTIVE);
      this.addOrRemoveClassListMethod(circle, this.CLASS_TRANSLATE_SLIDER_OFF, this.STATUS_REMOVE);
      this.addOrRemoveClassListMethod(circle, this.CLASS_TRANSLATE_SLIDER_OFF, this.STATUS_REMOVE);
      this.addOrRemoveClassListMethod(divSlider, this.CLASS_BACKGROUND_RED_SLIDER_ACTIVE, this.STATUS_ACTIVE);
      this.isPreferenceDtaFEmit.emit(this.isPreferenceData);
      this.isActive = false;
    }else{
      this.defaultPreference = this.ASW_NO;
      this.isPreferenceData = false;
      this.isActive = false;
      this.addOrRemoveClassListMethod(circle, this.CLASS_TRANSLATE_SLIDER_OFF, this.STATUS_ACTIVE);
      this.addOrRemoveClassListMethod(circle, this.CLASS_TRANSLATE_SLIDER_ON, this.STATUS_REMOVE);
      this.addOrRemoveClassListMethod(divSlider, this.CLASS_BACKGROUND_RED_SLIDER_ACTIVE, this.STATUS_REMOVE);
      this.isPreferenceDtaFEmit.emit(this.isPreferenceData);
    }
  }


  addOrRemoveClassListMethod(element: any, classStyle: string, action: string){
    if(action === this.STATUS_ACTIVE){
      element.classList.add(classStyle);
    }else{
      element.classList.remove(classStyle);
    }
  }




}
